import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ProductType} from "../../../model/enums/ProductType.enum";
import {Gender} from "../../../model/enums/Gender.enum";

@Component({
  selector: 'v-product-title',
  templateUrl: './product-title.component.html',
  styleUrls: ['./product-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductTitleComponent {
  @Input() title;
  @Input() brand;
  @Input() gender;
  @Input() type;
  @Input() collection;
  @Input() selectedVariantName;
  @Input() manufacturerProductName;

  constructor() { }

  computeGender(gender) {
    switch (gender) {
      case Gender.MALE:
        return 'productDetails.gender.men';
        break;
      case Gender.FEMALE:
        return 'productDetails.gender.women';
        break;
      case Gender.KID:
      case Gender.BOY:
      case Gender.GIRL:
        return 'productDetails.gender.kids';
    }
  }

  computeType(type) {
    switch (type) {
      case ProductType.SUNGLASSES:
        return "productDetails.type.sunglasses";
        break;
      case ProductType.FRAMES:
        return "productDetails.type.frames"
        break;
      case ProductType.CONTACT_LENS:
        return "productDetails.type.lenses"
        break;
    }
  }
}
